import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import reveal from './directives/reveal'
import './assets/tailwind.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

// Stop the browser from jumping back to the old scroll position after a refresh
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

createApp(App).use(router).use(reveal).mount('#app')
